<template>
    <div>
        <h1 class="font-weight-bold">Services</h1>
        <div>
            <b-row class="mt-3">
                <b-col>
                    <b-form-group label="" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="btn-radios-2"
                            v-model="isCompleted"
                            :options="completedStates"
                            :aria-describedby="ariaDescribedby"
                            button-variant="outline-primary"
                            name="radio-btn-outline"
                            buttons
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="outline-secondary" class="px-3">
                        <b-icon-filter variant="outline-secondary" class="mr-2">
                        </b-icon-filter>
                        Filter By
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <hr />
        <b-row class="my-4">
            <b-col
                md="4"
                cols="12"
                v-for="(order, idx) in orders.filter(
                    x => x.completed === isCompleted
                )"
                :key="'-order-no-' + idx"
            >
                <service-summary :order="order" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import ServiceSummary from './ServiceSummary'

export default {
    name: 'CustomerPortalServiceRequests',
    components: {
        ServiceSummary,
    },
    data() {
        return {
            openOrders: true,
            isCompleted: 0,
            completedStates: [
                { text: 'Active', value: 0 },
                { text: 'Closed', value: 1 },
            ],
        }
    },

    computed: {
        orders() {
            return this.$store.state.customerPortal.orders
        },
    },

    mounted() {
        this.$store.dispatch('customerPortal/fetchOrders')
    },

    methods: {
        toggleOpenOrders: function () {
            this.openOrders = !this.openOrders
        },
    },
}
</script>
